const domain = {
    status: {
        connecting: 'กำลังเชื่อมต่อ...',
        in_use: 'กำลังใช้งาน',
        failed_to_connect: 'เชื่อมต่อไม่สำเร็จ',
    },
    update_endpoint_notice: 'อย่าลืมอัปเดตโดเมนสำหรับ Social connector callback URI และ Logto endpoint ในแอปพลิเคชันของคุณ หากต้องการใช้โดเมนที่กำหนดเองสำหรับฟีเจอร์เหล่านี้',
    error_hint: 'โปรดตรวจสอบว่าคุณได้อัปเดตเรคคอร์ด DNS แล้ว เราจะตรวจสอบต่อไปทุก ๆ {{value}} วินาที',
    custom: {
        custom_domain: 'โดเมนที่กำหนดเอง',
        custom_domain_description: 'เพิ่มความโดดเด่นให้กับแบรนด์ของคุณด้วยการใช้โดเมนที่กำหนดเอง โดเมนนี้จะถูกนำมาใช้ในประสบการณ์ลงชื่อเข้าใช้งานของคุณ',
        custom_domain_field: 'โดเมนที่กำหนดเอง',
        custom_domain_placeholder: 'auth.domain.com',
        add_custom_domain_field: 'เพิ่มโดเมนแบบกำหนดเอง',
        custom_domains_field: 'โดเมนแบบกำหนดเอง',
        add_domain: 'เพิ่มโดเมน',
        invalid_domain_format: 'โปรดระบุ URL โดเมนที่ถูกต้องและประกอบด้วยอย่างน้อย 3 ส่วน เช่น "auth.domain.com."',
        verify_domain: 'ยืนยันโดเมน',
        enable_ssl: 'เปิดใช้ SSL',
        checking_dns_tip: 'หลังจากคุณตั้งค่าเรคคอร์ด DNS แล้ว ขั้นตอนจะเริ่มอัตโนมัติและอาจใช้เวลาไม่เกิน 24 ชั่วโมง คุณสามารถออกจากหน้านี้ได้ในขณะที่ดำเนินการ',
        enable_ssl_tip: 'การเปิดใช้ SSL จะเริ่มโดยอัตโนมัติและอาจใช้เวลาไม่เกิน 24 ชั่วโมง คุณสามารถออกจากหน้านี้ได้ในขณะที่ดำเนินการ',
        generating_dns_records: 'กำลังสร้างเรคคอร์ด DNS...',
        add_dns_records: 'กรุณาเพิ่มเรคคอร์ด DNS เหล่านี้กับผู้ให้บริการ DNS ของคุณ',
        dns_table: {
            type_field: 'ประเภท',
            name_field: 'ชื่อ',
            value_field: 'ค่า',
        },
        deletion: {
            delete_domain: 'ลบโดเมน',
            reminder: 'ลบโดเมนที่กำหนดเอง',
            description: 'คุณแน่ใจหรือว่าต้องการลบโดเมนที่กำหนดเองนี้?',
            in_used_description: 'คุณแน่ใจหรือว่าต้องการลบโดเมนที่กำหนดเอง "<span>{{domain}}</span>" นี้?',
            in_used_tip: 'หากคุณได้ตั้งค่าโดเมนที่กำหนดเองนี้ในผู้ให้บริการ social connector หรือแอปพลิเคชัน endpoint ก่อนหน้านี้ คุณจะต้องแก้ไข URI ให้เป็นโดเมน Logto ค่าเริ่มต้น "<span>{{domain}}</span>" ก่อน เพื่อให้ปุ่มลงชื่อเข้าใช้งานโซเชียลทำงานได้ถูกต้อง',
            deleted: 'ลบโดเมนที่กำหนดเองสำเร็จ!',
        },
        config_custom_domain_description: 'กำหนดค่าโดเมนแบบกำหนดเองเพื่อใช้งานฟีเจอร์ต่อไปนี้: แอปพลิเคชัน, ตัวเชื่อมต่อโซเชียล และตัวเชื่อมต่อองค์กร.',
        verification_files: {
            title: 'ไฟล์ยืนยันโดเมน',
            description: 'ให้บริการไฟล์ข้อความหรือ JSON ขนาดเล็กจากโดเมนที่กำหนดเองนี้ เพื่อยืนยันความเป็นเจ้าของโดเมนกับบริการของบุคคลที่สาม',
            add: 'เพิ่มไฟล์ยืนยัน',
            empty: 'ยังไม่ได้กำหนดค่าไฟล์ยืนยัน',
            path: 'เส้นทางไฟล์',
            content_type: 'ประเภทเนื้อหา',
            content_type_text: 'ข้อความธรรมดา',
            content_type_json: 'JSON',
            content: 'เนื้อหาไฟล์',
            content_placeholder: 'วางเนื้อหาที่ถูกต้องของไฟล์ยืนยัน',
            required: 'จำเป็นต้องกรอกข้อมูลในช่องนี้',
            invalid_path: 'ใช้ชื่อไฟล์ที่มีนามสกุลที่รูทของโดเมน หรือใช้เส้นทางภายใต้ /.well-known/ รองรับเฉพาะตัวอักษร ตัวเลข จุด ขีดกลาง และขีดล่าง',
            duplicate_path: 'มีไฟล์ยืนยันที่ใช้เส้นทางนี้อยู่แล้ว',
            content_too_long: 'เนื้อหาไฟล์ต้องไม่เกิน 16,384 อักขระ',
            invalid_json: 'ป้อนเนื้อหา JSON ที่ถูกต้อง',
        },
    },
    default: {
        default_domain: 'โดเมนเริ่มต้น',
        default_domain_description: 'Logto มีโดเมนเริ่มต้นที่ได้รับการกำหนดค่าไว้ล่วงหน้า พร้อมใช้งานโดยไม่ต้องตั้งค่าเพิ่มเติม โดเมนเริ่มต้นนี้จะใช้เป็นทางเลือกสำรอง แม้ว่าคุณจะเปิดใช้โดเมนที่กำหนดเองแล้วก็ตาม',
        default_domain_field: 'โดเมน Logto เริ่มต้น',
    },
    custom_endpoint_note: 'คุณสามารถปรับแต่งชื่อโดเมนของ endpoint เหล่านี้ตามที่คุณต้องการ เลือก "{{custom}}" หรือ "{{default}}"',
    custom_social_callback_url_note: 'คุณสามารถปรับแต่งชื่อโดเมนของ URI นี้ให้ตรงกับ endpoint ของแอปพลิเคชันของคุณ เลือก "{{custom}}" หรือ "{{default}}"',
    custom_acs_url_note: 'คุณสามารถปรับแต่งชื่อโดเมนของ URI นี้ให้ตรงกับ URL assertion consumer service ของผู้ให้บริการตัวตนของคุณ เลือก "{{custom}}" หรือ "{{default}}"',
    switch_custom_domain_tip: 'สลับโดเมนเพื่อดู endpoint ที่สอดคล้องกัน เพิ่มโดเมนเพิ่มเติมได้ผ่าน <a>โดเมนที่กำหนดเอง</a>.',
    switch_saml_app_domain_tip: 'สลับโดเมนเพื่อดู URL ที่เกี่ยวข้อง สำหรับโปรโตคอล SAML เมตาดาทา URL สามารถโฮสต์บนโดเมนที่เข้าถึงได้ใด ๆ แต่โดเมนที่เลือกจะกำหนด SSO service URL ที่ SP ใช้ในการเปลี่ยนเส้นทางผู้ใช้เพื่อยืนยันตัวตน ซึ่งส่งผลต่อประสบการณ์การล็อกอินและการมองเห็น URL.',
    switch_saml_connector_domain_tip: 'สลับโดเมนเพื่อดู URL ที่เกี่ยวข้อง โดเมนที่เลือกจะกำหนด ACS URL ซึ่งมีผลต่อปลายทางที่ผู้ใช้ถูกเปลี่ยนเส้นทางหลังจากเข้าสู่ระบบ SSO เลือกโดเมนที่ตรงกับพฤติกรรมการเปลี่ยนเส้นทางที่แอปของคุณคาดหวัง.',
};
export default Object.freeze(domain);
